module.exports = __webpack_public_path__ + "static/img/freja-btn.a645f2e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/freja-btn.svg?data
// module id = oC4A
// module chunks = 1